import React from 'react'

let loaderComp = <div>načítám</div>

export const registerLoader = (loader: JSX.Element) => {
  loaderComp = loader
}

const Loading = () => {
  return loaderComp
}

export default Loading